/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminCompany,
    AdminCompanyFromJSON,
    AdminCompanyFromJSONTyped,
    AdminCompanyToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001
     */
    currentPage?: number;
    /**
     * 
     * @type {Array<AdminCompany>}
     * @memberof InlineResponse2001
     */
    data?: Array<AdminCompany>;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2001
     */
    firstPageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001
     */
    lastPage?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2001
     */
    lastPageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2001
     */
    nextPageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2001
     */
    path?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001
     */
    perPage?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2001
     */
    prevPageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001
     */
    total?: number;
}

export function InlineResponse2001FromJSON(json: any): InlineResponse2001 {
    return InlineResponse2001FromJSONTyped(json, false);
}

export function InlineResponse2001FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse2001 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currentPage': !exists(json, 'current_page') ? undefined : json['current_page'],
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(AdminCompanyFromJSON)),
        'firstPageUrl': !exists(json, 'first_page_url') ? undefined : json['first_page_url'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'lastPage': !exists(json, 'last_page') ? undefined : json['last_page'],
        'lastPageUrl': !exists(json, 'last_page_url') ? undefined : json['last_page_url'],
        'nextPageUrl': !exists(json, 'next_page_url') ? undefined : json['next_page_url'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'perPage': !exists(json, 'per_page') ? undefined : json['per_page'],
        'prevPageUrl': !exists(json, 'prev_page_url') ? undefined : json['prev_page_url'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function InlineResponse2001ToJSON(value?: InlineResponse2001 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'current_page': value.currentPage,
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(AdminCompanyToJSON)),
        'first_page_url': value.firstPageUrl,
        'from': value.from,
        'last_page': value.lastPage,
        'last_page_url': value.lastPageUrl,
        'next_page_url': value.nextPageUrl,
        'path': value.path,
        'per_page': value.perPage,
        'prev_page_url': value.prevPageUrl,
        'to': value.to,
        'total': value.total,
    };
}


